import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import { Alert, AlertTitle } from '@material-ui/lab';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';


const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: "100%",
    },
    marginRight: theme.spacing(1),
  },
  grid: {
    flexGrow: 1,
  },
  listHelperText: {
    display: "flex",
    justifyContent: "space-between",
  },
}));

export default function ChooseDataByListStep(props) {
  const {
    datasets,
    selectedObjects,
    selectedObjectsOk,
    onDescriptionChange,
    onSelectedObjectsChange,
    onSelectedObjectsOk,
  } = props;
  
  const [ listErrors, setListErrors ] = React.useState([]);
  const [ errorIndex, setErrorIndex ] = React.useState(0);
  const [ validUriCount, setValidUriCount ] = React.useState(0);
  
  const classes = useStyles();
  const sourcePrefixes = datasets.map(d => d.Location.S3Uri);
  const handleUpload = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    reader.onload = (e) => {
      const text = (e.target.result);
      if(onSelectedObjectsChange) {
        onSelectedObjectsChange(
          selectedObjects + 
          ((selectedObjects.length===0 || selectedObjects.endsWith('\n'))?'':'\n') +
          text);
      }
    };
    reader.readAsText(e.target.files[0]);
  };

  const handleVerify = () => {
    let lines=selectedObjects.split('\n');
    let errors=[];
    let uriLines=0;
    let headerDesc=null;
    lines.forEach( (line, i) => {
      let trimline=line.trim();
      if(trimline.startsWith("s3://")) {
        if(sourcePrefixes.some(p => trimline.startsWith(p))) {
          uriLines++;
        } else {
          errors.push({
            issue: "line "+(i+1)+": must reference a key in "+(sourcePrefixes.length===1?"":"one of ")+
              "the source dataset location"+(sourcePrefixes.length===1?"":"s")+
              ": "+sourcePrefixes.join(", "),
            line: trimline,
          });
        }
      } else if(trimline.length && !trimline.startsWith('#')) {
        errors.push({
          issue: "line "+(i+1)+": must start with s3:// or a comment # mark",
          line: trimline,
        });
      } else if(trimline.startsWith('# ') && i<3 && trimline.length>2) {
        headerDesc=trimline.substring(2);
      }
    });
    if(uriLines===0) {
      errors.push({
        issue: "You must have at least one line that begins with s3:// and references an object located in one of the workload's source datasets.",
        line: null,
      });
    } 
    setErrorIndex(0);
    setValidUriCount(uriLines);
    if(errors.length) {
      setListErrors(errors);
    } else {
      setListErrors([]);
    }
    if(onSelectedObjectsOk) {
      onSelectedObjectsOk(errors.length===0);
    }
    if(onDescriptionChange && headerDesc) {
      onDescriptionChange(headerDesc);
    }
  };
  
  const handleSelectedObjectsChange = (event) => {
    if(onSelectedObjectsChange) {
      onSelectedObjectsChange(event.target.value);
    }
  };
  
  React.useEffect(() => {
    if(listErrors.length>0) {
      const error=listErrors[errorIndex];
      if(error && error.line) {
        const pStart=selectedObjects.indexOf(error.line);
        const pEnd=pStart+error.line.length;
        const input = document.getElementById('selected-objects');
        input.focus();
        input.setSelectionRange(pStart, pEnd);
      }
    }
  }, [listErrors,errorIndex,selectedObjects ]);
  
  return (
    <form className={classes.root} noValidate autoComplete="off">
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography color="textSecondary">
            1. Enter or upload ( <label htmlFor="icon-button-file">
                    <IconButton color="primary" size="small" component="span">
                      <CloudUploadIcon/>
                    </IconButton>
                  </label> ) a list of objects you wish to process
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="selected-objects" required
            multiline
            rows={5}
            label="List of objects"
            placeholder="s3://bucket/key"
            value={selectedObjects}
            onChange={handleSelectedObjectsChange}
            variant="outlined" size="small"
            InputLabelProps={{
              shrink: true,
            }}
            margin="dense"
            style={{ fontSize: "small", fontFamily: "Courier" }}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography color="textSecondary">
            2. Verify ( <IconButton color="primary" size="small" component="span" onClick={handleVerify}>
                    <CheckCircleIcon/>
                  </IconButton> ) URI list syntax
          </Typography>
        </Grid>
        { listErrors.length>0?
          <Grid item xs={12}>
            <Alert severity="error">
              {listErrors.length>1?
                <AlertTitle>
                  Error {errorIndex+1} of {listErrors.length}
                  <IconButton color="inherit" size="small" onClick={() => setErrorIndex(prev => prev>0?prev-1:(listErrors.length-1))}>
                    <NavigateNextIcon style={{ transform: 'rotate(180deg)' }}/>
                  </IconButton>
                  <IconButton color="inherit" size="small" onClick={() => setErrorIndex(prev => prev<(listErrors.length-1)?prev+1:0)}>
                    <NavigateNextIcon/>
                  </IconButton>
                </AlertTitle>:null
              }
              {listErrors[errorIndex].issue}
            </Alert>
          </Grid>:null
        }
        { selectedObjectsOk?
          <Grid item xs={12}>
            <Alert severity="success">
              {validUriCount} S3 URI{validUriCount===1?"":"s"} are valid and referencing workload datasets.
            </Alert>
          </Grid>:null
        }
      </Grid>
      <input id="icon-button-file" type="file" hidden onChange={handleUpload}/>
    </form>
  );
}

        // <Grid item xs={12}>
        //   <Button variant="contained" component="label">
        //     Upload File
        //     <input type="file" hidden onChange={handleUpload}/>
        //   </Button>
        // </Grid>

ChooseDataByListStep.propTypes = {
  datasets: PropTypes.array.isRequired,
  selectedObjects: PropTypes.string.isRequired,
  selectedObjectsOk: PropTypes.bool.isRequired,
  onDescriptionChange: PropTypes.func,
  onSelectedObjectsChange: PropTypes.func,
  onSelectedObjectsOk: PropTypes.func,
};

